"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomePricingTableCell = void 0;
const Pricing_1 = require("../entity/Pricing");
const PricingPoint_1 = require("../entity/PricingPoint");
const pricingPoint_1 = require("./pricingPoint");
const createSomePricingTableCell = ({ supportingPlaybackTimeLength = '123', supportingAspectRatioKey = '456', prices = PricingPoint_1.PricingPointKey.map(key => pricingPoint_1.createSomePricingPoint({ key })), } = {}) => new Pricing_1.PricingTableCell({ supportingPlaybackTimeLength, supportingAspectRatioKey, prices });
exports.createSomePricingTableCell = createSomePricingTableCell;
